export const COLORS = {
  BASE_WHITE: '#ffffff',
  BASE_BLACK: '#000000',
  GRAY_25: '#fdfdfc',
  GRAY_50: '#fafaf9',
  GRAY_100: '#f5f5f4',
  GRAY_200: '#e5e5e5',
  GRAY_300: '#d6d6d6',
  GRAY_400: '#a3a3a3',
  GRAY_450: '#858585',
  GRAY_500: '#737373',
  GRAY_600: '#525252',
  GRAY_700: '#424242',
  GRAY_800: '#292929',
  GRAY_900: '#141414',
  PRIMARY_25: '#fafcfc',
  PRIMARY_50: '#eff3f3',
  PRIMARY_100: '#e1e7e8',
  PRIMARY_200: '#cfdadb',
  PRIMARY_300: '#a0bbbd',
  PRIMARY_400: '#82a3a6',
  PRIMARY_500: '#5b848a',
  PRIMARY_600: '#457176',
  PRIMARY_700: '#36575a',
  PRIMARY_800: '#233b3d',
  PRIMARY_900: '#142627',
  ERROR_25: '#fefbfa',
  ERROR_50: '#fdf1ed',
  ERROR_200: '#f7d0c5',
  ERROR_100: '#fbe4dd',
  ERROR_400: '#dd846d',
  ERROR_300: '#ecaa98',
  ERROR_500: '#cc5d44',
  ERROR_600: '#c24830',
  ERROR_700: '#9e3b28',
  ERROR_800: '#7a2f20',
  ERROR_900: '#592318',
  WARNING_25: '#fbf5ef',
  WARNING_50: '#f8f0e6',
  WARNING_100: '#f5e6d3',
  WARNING_200: '#f3dbbf',
  WARNING_500: '#dca762',
  WARNING_300: '#eccca2',
  WARNING_400: '#e3b77d',
  WARNING_600: '#ce9036',
  WARNING_700: '#a37b3f',
  WARNING_800: '#7b5217',
  WARNING_900: '#54360a',
  SUCCESS_25: '#fafdf3',
  SUCCESS_50: '#f5f8ec',
  SUCCESS_100: '#eaf0dc',
  SUCCESS_200: '#d9e4c3',
  SUCCESS_300: '#cedcb2',
  SUCCESS_400: '#acc482',
  SUCCESS_500: '#9ab86a',
  SUCCESS_700: '#5b7542',
  SUCCESS_600: '#799656',
  SUCCESS_800: '#3f562f',
  SUCCESS_900: '#26381d',
  GRAY_GREEN_25: '#f9f9f8',
  GRAY_GREEN_50: '#f3f3f2',
  GRAY_GREEN_100: '#edeeeb',
  GRAY_GREEN_200: '#e7e8e5',
  GRAY_GREEN_500: '#8c978f',
  GRAY_GREEN_300: '#cfd1cd',
  GRAY_GREEN_400: '#b7bcb5',
  GRAY_GREEN_600: '#7a8880',
  GRAY_GREEN_700: '#687972',
  GRAY_GREEN_800: '#57645f',
  GRAY_GREEN_900: '#363c3a',
  SECONDARY_25: '#f4fae2',
  SECONDARY_50: '#e8f1d2',
  SECONDARY_200: '#d0ddb2',
  SECONDARY_400: '#93b08f',
  SECONDARY_500: '#749b7e',
  SECONDARY_300: '#b1c7a0',
  SECONDARY_100: '#dde6c1',
  SECONDARY_600: '#587f68',
  SECONDARY_700: '#3c6550',
  SECONDARY_800: '#224b3a',
  SECONDARY_900: '#093225',
  YELLOW_25: '#fdf9ef',
  YELLOW_50: '#fcf3de',
  YELLOW_100: '#fbeecd',
  YELLOW_200: '#fae8bc',
  YELLOW_300: '#f7dc9a',
  YELLOW_400: '#f4cf73',
  YELLOW_500: '#f0c454',
  YELLOW_600: '#d1aa48',
  YELLOW_700: '#b2913c',
  YELLOW_800: '#957931',
  YELLOW_900: '#786126',
  BRICK_25: '#fef9f7',
  BRICK_50: '#fdf3ef',
  BRICK_100: '#fcede7',
  BRICK_200: '#f7d6c8',
  BRICK_300: '#edb39b',
  BRICK_400: '#e0916f',
  BRICK_500: '#cc6d44',
  BRICK_600: '#bc6039',
  BRICK_700: '#9c4f2e',
  BRICK_800: '#7e3f24',
  BRICK_900: '#612f1a',
  INFO_25: '#f6f9fc',
  INFO_50: '#f0f5fa',
  INFO_100: '#e5edf7',
  INFO_200: '#d5e1f1',
  INFO_300: '#b3c9e6',
  INFO_400: '#78a3d3',
  INFO_500: '#4e8dc8',
  INFO_600: '#3d6e9c',
  INFO_700: '#31587c',
  INFO_800: '#25435e',
  INFO_900: '#162838',
}
